/*
 * FRENESI · «Avise-me quando chegar» (20/10/2026), no lugar do app STOQ.
 *
 * Uma caixa só, aberta pelo cartão esgotado da vitrine (assets/fv-cartao.js
 * chama `FrenesiAvise.abrir`) e pelo botão da página do produto
 * ([data-fv-avise-pdp], sections/fv-produto). A pessoa escolhe o tamanho
 * esgotado, deixa o e-mail e o pedido vai para o ERP, que manda UM e-mail no
 * padrão da casa quando o tamanho voltar.
 *
 *   POST https://checkout.frenesiperfumes.com.br/api/publico/avise-me
 *   { email, variante, origem: 'cartao' | 'produto', marketing, site }
 *
 * O produto vem do /products/<handle>.js da própria loja; o texto que chega
 * de fora entra por textContent. `site` é a isca de robô (fica escondido).
 * «e‑mail» leva o hífen que não quebra: no celular a linha partia em «e-» e «mail».
 */
(function () {
  'use strict';
  if (window.FrenesiAvise) return;

  var API = 'https://checkout.frenesiperfumes.com.br/api/publico/avise-me';
  var CHAVE_EMAIL = 'fv-avise-email';
  var script = document.currentScript;
  var emailDaConta = (script && script.getAttribute('data-email')) || '';

  function el(tag, classe, texto) {
    var n = document.createElement(tag);
    if (classe) n.className = classe;
    if (texto != null) n.textContent = texto;
    return n;
  }
  function tamanho(titulo) {
    var t = String(titulo || '').trim();
    if (!t || /^default title$/i.test(t)) return '';
    return t.replace(/^(\d+(?:[.,]\d+)?)\s*ml$/i, '$1 ml');
  }
  function nome(titulo) {
    return String(titulo || '').replace(/\s*\((?:decants?)\)\s*/gi, ' ').replace(/\s+/g, ' ').trim();
  }
  function lerEmail() {
    try { return window.localStorage.getItem(CHAVE_EMAIL) || ''; } catch (e) { return ''; }
  }
  function gravarEmail(v) {
    try { window.localStorage.setItem(CHAVE_EMAIL, v); } catch (e) {}
  }

  var ESTILO = [
    '.fv-avise{width:420px;max-width:calc(100vw - 24px);max-height:calc(100dvh - 24px);box-sizing:border-box;margin:auto;padding:0;border:0;border-radius:20px;background:#fff;color:#111;box-shadow:0 30px 80px rgb(17 17 17 / .28);font-family:var(--font-body--family,Inter,sans-serif);overflow:auto}',
    '.fv-avise::backdrop{background:rgb(17 17 17 / .45)}',
    '.fv-avise__caixa{position:relative;padding:26px 24px 20px}',
    '.fv-avise__fechar{position:absolute;top:10px;right:10px;width:40px;height:40px;border:0;border-radius:50%;background:none;color:#8a837a;font-size:26px;line-height:1;cursor:pointer}',
    '.fv-avise__fechar:hover{background:#f5f1ea;color:#111}',
    '.fv-avise__olho{margin:0;padding-right:40px;font-size:11px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#a47e2f}',
    '.fv-avise__produto{display:flex;align-items:center;gap:14px;margin-top:12px}',
    '.fv-avise__foto{flex:0 0 64px;width:64px;height:64px;border-radius:14px;background:#faf7f2;box-shadow:inset 0 0 0 1px #efe6d6;overflow:hidden}',
    '.fv-avise__foto img{display:block;width:100%;height:100%;object-fit:cover;mix-blend-mode:multiply}',
    '.fv-avise__titulo{margin:0;font-family:var(--font-heading--family,"Playfair Display",serif);font-size:20px;line-height:1.25;text-wrap:balance}',
    '.fv-avise__rotulo{display:block;margin:18px 0 8px;font-size:12px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:#5f5a54}',
    '.fv-avise__tams{display:flex;flex-wrap:wrap;gap:8px;margin:0;padding:0;border:0}',
    '.fv-avise__tam{min-width:64px;min-height:44px;padding:0 14px;border:1px solid #d9d2c6;border-radius:999px;background:#fff;color:#111;font:inherit;font-size:14px;cursor:pointer}',
    '.fv-avise__tam[aria-checked="true"]{border-color:#111;background:#111;color:#fff}',
    '.fv-avise__campo{display:block;box-sizing:border-box;width:100%;min-height:48px;padding:0 14px;border:1px solid #d9d2c6;border-radius:12px;background:#fff;color:#111;font:inherit;font-size:16px}',
    '.fv-avise__campo:focus{outline:2px solid #a47e2f;outline-offset:1px;border-color:#a47e2f}',
    '.fv-avise__aceite{display:flex;gap:10px;align-items:flex-start;margin-top:14px;color:#5f5a54;font-size:13px;line-height:1.45;cursor:pointer}',
    '.fv-avise__aceite input{flex:0 0 18px;width:18px;height:18px;margin:1px 0 0;accent-color:#111}',
    '.fv-avise__botao{display:block;width:100%;min-height:52px;margin-top:18px;border:0;border-radius:12px;background:#111;color:#fff;font:inherit;font-size:13px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;cursor:pointer}',
    '.fv-avise__botao:hover{background:#2a2622}',
    '.fv-avise__botao[disabled]{opacity:.6;cursor:progress}',
    '.fv-avise__nota{margin:12px 0 0;color:#8a837a;font-size:12.5px;line-height:1.5;text-align:center}',
    '.fv-avise__erro{margin:12px 0 0;color:#a3362c;font-size:13.5px;line-height:1.45}',
    '.fv-avise__erro a{color:inherit;font-weight:600}',
    '.fv-avise__isca{position:absolute!important;left:-9999px!important;width:1px;height:1px;overflow:hidden}',
    '.fv-avise__ok{padding:6px 0 2px;text-align:center}',
    '.fv-avise__selo{display:grid;place-items:center;width:56px;height:56px;margin:4px auto 0;border-radius:50%;background:#f5efe3;color:#a47e2f;font-size:26px}',
    '.fv-avise__ok .fv-avise__titulo{margin-top:14px}',
    '.fv-avise__ok p{margin:10px 0 0;color:#5f5a54;font-size:14px;line-height:1.55}',
    '.fv-avise button:focus-visible,.fv-avise a:focus-visible{outline:2px solid #a47e2f;outline-offset:2px}',
    '@media (max-width:749px){.fv-avise{margin:auto 0 0;width:100%;max-width:100%;border-radius:20px 20px 0 0}.fv-avise__caixa{padding:24px 18px calc(18px + env(safe-area-inset-bottom))}}'
  ].join('');

  var dialogo = null;
  function caixa() {
    if (dialogo) return dialogo;
    if (!document.getElementById('fv-avise-estilo')) {
      var s = el('style');
      s.id = 'fv-avise-estilo';
      s.textContent = ESTILO;
      document.head.appendChild(s);
    }
    dialogo = el('dialog', 'fv-avise');
    dialogo.setAttribute('aria-labelledby', 'fv-avise-titulo');
    dialogo.addEventListener('click', function (e) {
      if (e.target === dialogo) dialogo.close();
    });
    document.body.appendChild(dialogo);
    return dialogo;
  }

  function botaoFechar(d) {
    var x = el('button', 'fv-avise__fechar', '×');
    x.type = 'button';
    x.setAttribute('aria-label', 'Fechar');
    x.addEventListener('click', function () { d.close(); });
    return x;
  }

  function cabecalho(produto, olho) {
    var frag = document.createDocumentFragment();
    frag.appendChild(el('p', 'fv-avise__olho', olho));
    var linha = el('div', 'fv-avise__produto');
    if (produto.featured_image) {
      var foto = el('div', 'fv-avise__foto');
      var img = el('img');
      img.src = String(produto.featured_image).replace(/^\/\//, 'https://') + (String(produto.featured_image).indexOf('?') < 0 ? '?width=160' : '&width=160');
      img.alt = '';
      img.width = 64;
      img.height = 64;
      foto.appendChild(img);
      linha.appendChild(foto);
    }
    var t = el('p', 'fv-avise__titulo', nome(produto.title));
    t.id = 'fv-avise-titulo';
    linha.appendChild(t);
    frag.appendChild(linha);
    return frag;
  }

  function sucesso(d, produto, variante, email, jaEstava) {
    var c = el('div', 'fv-avise__caixa');
    c.appendChild(botaoFechar(d));
    var ok = el('div', 'fv-avise__ok');
    var selo = el('div', 'fv-avise__selo', '✓');
    selo.setAttribute('aria-hidden', 'true');
    ok.appendChild(selo);
    var t = el('p', 'fv-avise__titulo', jaEstava ? 'Você já está na lista' : 'Pronto, avisaremos você');
    t.id = 'fv-avise-titulo';
    ok.appendChild(t);
    var tam = tamanho(variante.title);
    var p = el('p');
    p.appendChild(document.createTextNode('Assim que '));
    p.appendChild(el('b', null, nome(produto.title) + (tam ? ' ' + tam : '')));
    p.appendChild(document.createTextNode(' voltar, enviamos um e\u2011mail para '));
    p.appendChild(el('b', null, email));
    p.appendChild(document.createTextNode('.'));
    ok.appendChild(p);
    var seguir = el('button', 'fv-avise__botao', 'Continuar comprando');
    seguir.type = 'button';
    seguir.addEventListener('click', function () { d.close(); });
    ok.appendChild(seguir);
    c.appendChild(ok);
    d.textContent = '';
    d.appendChild(c);
    seguir.focus();
  }

  function formulario(d, produto, esgotadas, escolhida, origem) {
    var c = el('form', 'fv-avise__caixa');
    c.noValidate = true;
    c.appendChild(botaoFechar(d));
    c.appendChild(cabecalho(produto, 'Avise-me quando chegar'));

    var atual = escolhida;
    var comTamanho = esgotadas.some(function (v) { return tamanho(v.title); });
    if (comTamanho) {
      c.appendChild(el('span', 'fv-avise__rotulo', esgotadas.length > 1 ? 'Qual tamanho?' : 'Tamanho'));
      var grupo = el('div', 'fv-avise__tams');
      grupo.setAttribute('role', 'radiogroup');
      grupo.setAttribute('aria-label', 'Tamanho esgotado');
      esgotadas.forEach(function (v) {
        var b = el('button', 'fv-avise__tam', tamanho(v.title) || v.title);
        b.type = 'button';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', String(v.id === atual.id));
        b.addEventListener('click', function () {
          atual = v;
          grupo.querySelectorAll('.fv-avise__tam').forEach(function (o) { o.setAttribute('aria-checked', String(o === b)); });
        });
        grupo.appendChild(b);
      });
      c.appendChild(grupo);
    }

    var rotulo = el('label', 'fv-avise__rotulo', 'Seu e\u2011mail');
    rotulo.htmlFor = 'fv-avise-email';
    c.appendChild(rotulo);
    var campo = el('input', 'fv-avise__campo');
    campo.id = 'fv-avise-email';
    campo.type = 'email';
    campo.name = 'email';
    campo.autocomplete = 'email';
    campo.inputMode = 'email';
    campo.required = true;
    campo.placeholder = 'seuemail@exemplo.com';
    campo.value = emailDaConta || lerEmail();
    c.appendChild(campo);

    var isca = el('input', 'fv-avise__isca');
    isca.type = 'text';
    isca.name = 'site';
    isca.tabIndex = -1;
    isca.autocomplete = 'off';
    isca.setAttribute('aria-hidden', 'true');
    c.appendChild(isca);

    var aceite = el('label', 'fv-avise__aceite');
    var marca = el('input');
    marca.type = 'checkbox';
    marca.name = 'marketing';
    aceite.appendChild(marca);
    aceite.appendChild(el('span', null, 'Quero receber novidades e ofertas da Frenesi por e\u2011mail.'));
    c.appendChild(aceite);

    var erro = el('p', 'fv-avise__erro');
    erro.setAttribute('role', 'alert');
    erro.hidden = true;
    c.appendChild(erro);

    var enviar = el('button', 'fv-avise__botao', 'Avise-me');
    enviar.type = 'submit';
    c.appendChild(enviar);
    c.appendChild(el('p', 'fv-avise__nota', 'Enviamos um único e\u2011mail quando este tamanho voltar ao estoque.'));

    function falhar(texto, comLink) {
      erro.textContent = texto;
      if (comLink) {
        erro.appendChild(document.createTextNode(' '));
        var a = el('a', null, 'Ver agora');
        a.href = '/products/' + produto.handle + '?variant=' + atual.id;
        erro.appendChild(a);
      }
      erro.hidden = false;
    }

    c.addEventListener('submit', function (e) {
      e.preventDefault();
      erro.hidden = true;
      var email = campo.value.trim().toLowerCase();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        falhar('Confira o e\u2011mail: ele parece incompleto.');
        campo.focus();
        return;
      }
      enviar.disabled = true;
      enviar.textContent = 'Enviando…';
      fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({ email: email, variante: atual.id, origem: origem, marketing: marca.checked, site: isca.value })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (corpo) { return { ok: r.ok, corpo: corpo }; }); })
        .then(function (r) {
          if (r.ok && r.corpo && r.corpo.ok) {
            gravarEmail(email);
            sucesso(d, produto, atual, email, r.corpo.jaEstava === true);
            return;
          }
          falhar((r.corpo && r.corpo.erro) || 'Não conseguimos registrar agora. Tente de novo em instantes.', r.corpo && r.corpo.disponivel);
        })
        ['catch'](function () { falhar('Sem conexão agora. Confira a internet e tente de novo.'); })
        .then(function () {
          enviar.disabled = false;
          enviar.textContent = 'Avise-me';
        });
    });

    d.textContent = '';
    d.appendChild(c);
    if (!campo.value) campo.focus();
    else enviar.focus();
  }

  /**
   * Abre a caixa. `url` é o endereço do produto (o cartão passa o href dele);
   * `variante`, o tamanho já escolhido, quando houver.
   */
  function abrir(opcoes) {
    var url = String((opcoes && opcoes.url) || '').split('?')[0].split('#')[0];
    if (!url) return Promise.reject(new Error('sem produto'));
    return fetch(url.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then(function (produto) {
        var esgotadas = (produto.variants || []).filter(function (v) { return !v.available; });
        if (!esgotadas.length) {
          window.location.href = url;
          return;
        }
        var pedida = String((opcoes && opcoes.variante) || '');
        var escolhida = esgotadas.filter(function (v) { return String(v.id) === pedida; })[0] || esgotadas[0];
        var d = caixa();
        formulario(d, produto, esgotadas, escolhida, opcoes.origem === 'cartao' ? 'cartao' : 'produto');
        if (!d.open) d.showModal();
      });
  }

  window.FrenesiAvise = { abrir: abrir };

  /* O botão da página do produto. Sem caixa (navegador antigo), nada muda. */
  document.addEventListener('click', function (e) {
    var b = e.target instanceof Element ? e.target.closest('[data-fv-avise-pdp]') : null;
    if (!b || typeof HTMLDialogElement === 'undefined') return;
    e.preventDefault();
    abrir({ url: '/products/' + b.getAttribute('data-handle'), variante: b.getAttribute('data-variante'), origem: 'produto' })['catch'](function () {});
  });
})();
